function findOffset(element) {
    var top = 0, left = 0;
  
    do {
      top += element.offsetTop  || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while(element);
  
    return {
      top: top,
      left: left
    };
}

window.onload = function () {
  var menuMobile = document.querySelector("#menu-mobile");
  const MENU_ACTIVE_CLASS = "active";

  document.querySelector("#open-menu-mobile").addEventListener("click", _ => {
    menuMobile.classList.add(MENU_ACTIVE_CLASS);
  });
  document.querySelector(".c-menu-mobile__background").addEventListener("click", _ => {
    menuMobile.classList.remove(MENU_ACTIVE_CLASS);
  });
  document.querySelector(".c-menu-mobile__close").addEventListener("click", _ => {
    menuMobile.classList.remove(MENU_ACTIVE_CLASS);
  });

  var stickyHeader = document.getElementById('custom-header');
  if (!stickyHeader) {
    return;
  }

  var headerOffset = findOffset(stickyHeader);

  // document.documentElement.onscroll = scroll;
  // document.body.onscroll = scroll;
  document.querySelector("#body").onscroll = scroll;

  function scroll() {
    // body.scrollTop is deprecated and no longer available on Firefox
    //var bodyScrollTop = $("#body").scrollTop();
    var bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector("#body").scrollTop;

    if (bodyScrollTop > headerOffset.top) {
      stickyHeader.classList.add('scrolled');
      $("#logo-rot").removeClass("hide");
      $("#logo-weiss").addClass("hide");
    } else {
      stickyHeader.classList.remove('scrolled');
      $("#logo-rot").addClass("hide");
      $("#logo-weiss").removeClass("hide");
    }
  };
};